import { ApiPost } from './Api'

const configData = window.CS_CONFIG

export const LogLevel = {
    Trace: 'Trace',
    Debug: 'Debug',
    Information: 'Information',
    Warning: 'Warning',
    Error: 'Error',
    Critical: 'Critical'
}

export const Log = (level: string, message: string): void => {
    message = `UI Message ${message}`
    if (configData.Env !== 'production') {
        // eslint-disable-next-line no-console
        console.log(message)
    }
    // eslint-disable-next-line no-console
    ApiPost('log', undefined, { level, message }).catch(console.log)
}